import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home'),
  },
  {
    path: '/solution',
    name: 'Solution',
    component: () => import(/* webpackChunkName: "solution" */ '../views/Solution'),
    children: [],
  },
  {
    path: '/microclimate',
    name: 'Microclimate',
    component: () => import(/* webpackChunkName: "Microclimate" */ '../views/Microclimate'),
  },
  {
    path: '/Water',
    name: 'Water',
    component: () => import(/* webpackChunkName: "Water" */ '../views/Water'),
  },

  {
    path: '/Keep',
    name: 'Keep',
    component: () => import(/* webpackChunkName: "Keep" */ '../views/Keep'),
  },
  {
    path: '/Light',
    name: 'Light',
    component: () => import(/* webpackChunkName: "Light" */ '../views/Light'),
  },

  {
    path: '/product/:pro',
    name: 'Product',
    component: () => import(/* webpackChunkName: "product" */ '../views/Product'),
  },
  {
    path: '/news/:id?',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News'),
  },
  {
    path: '/Cooperation',
    name: 'Cooperation',
    component: () => import(/* webpackChunkName: "solution" */ '../views/Cooperation'),
  },
  {
    path: '/JoinUs',
    name: 'JoinUs',
    component: () => import(/* webpackChunkName: "join" */ '../views/JoinUs'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About'),
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404'),
  },
  {
    path: '/article',
    name: 'article',
    component: () => import(/* webpackChunkName: "404" */ '../views/news-article'),
  },
  {
    path: '/SolutioCompare',
    name: 'SolutioCompare',
    component: () => import(/* webpackChunkName: "solution" */ '../views/Solution-compare'),
  },
  {
    path: '/Commercial',
    name: 'Commercial',
    component: () => import(/* webpackChunkName: "solution" */ '../views/Commercial'),
  },
  {
    path: '/residence',
    name: 'Residence',
    component: () => import(/* webpackChunkName: "solution" */ '../views/Residence'),
  },
  {
    path: '/experience',
    name: 'Experience',
    component: () => import(/* webpackChunkName: "solution" */ '../views/Experience'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(to, from, savedPosition)
    document.documentElement.scrollTop = 0
    return { x: 0, y: 0 }
  },
})

export default router
